"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeishuFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.FeishuFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M3 20.9995C3 19.3089 4.1252 17.825 5.75283 17.3691L58.2488 2.6665L58.1699 2.74536L58.2659 2.67821L43.0136 17.9119C42.8389 17.8777 42.6587 17.8598 42.4741 17.8598C40.9352 17.8598 39.6875 19.1074 39.6875 20.6465C39.6875 20.8299 39.7051 21.0091 39.7389 21.1826L27.3037 33.6025L14.0208 33.5892L14.0234 33.5873L4.10395 23.6653C3.39709 22.9583 3 21.9994 3 20.9995ZM42.0064 60.0388C43.6803 60.0388 45.1493 58.9132 45.6005 57.2852L60.204 4.71469L45.1632 19.9136C45.2267 20.147 45.2605 20.3925 45.2605 20.6459C45.2605 22.185 44.0125 23.4326 42.4736 23.4326C42.2304 23.4326 41.9944 23.4015 41.7696 23.3429L29.5181 35.723V48.9862L29.5208 48.9886V49.0857L29.5603 49.0286L39.3672 58.9345C40.0672 59.6414 41.0165 60.0388 42.0064 60.0388Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }));
    },
    name: 'feishu_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M3 20.9995C3 19.3089 4.1252 17.825 5.75283 17.3691L58.2488 2.6665L58.1699 2.74536L58.2659 2.67821L43.0136 17.9119C42.8389 17.8777 42.6587 17.8598 42.4741 17.8598C40.9352 17.8598 39.6875 19.1074 39.6875 20.6465C39.6875 20.8299 39.7051 21.0091 39.7389 21.1826L27.3037 33.6025L14.0208 33.5892L14.0234 33.5873L4.10395 23.6653C3.39709 22.9583 3 21.9994 3 20.9995ZM42.0064 60.0388C43.6803 60.0388 45.1493 58.9132 45.6005 57.2852L60.204 4.71469L45.1632 19.9136C45.2267 20.147 45.2605 20.3925 45.2605 20.6459C45.2605 22.185 44.0125 23.4326 42.4736 23.4326C42.2304 23.4326 41.9944 23.4015 41.7696 23.3429L29.5181 35.723V48.9862L29.5208 48.9886V49.0857L29.5603 49.0286L39.3672 58.9345C40.0672 59.6414 41.0165 60.0388 42.0064 60.0388Z'],
    width: '64',
    height: '64',
    viewBox: '0 0 64 64',
});
